export default __webpack_public_path__ + "static/media/vitra_chair_07.fa320ec5.jpg";